import { Fragment, useState } from 'react';

import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';

import { ReactComponent as ProPlus } from '../../../assets/proPlus.svg';
import Survey from '../Survey';
import useSurvey from 'store/survey/useSurvey';
import usePatient from 'store/patient/usePatient';
import useStudent from 'store/student/useStudent';
import useNotification from 'hooks/useNotification';
import { IToggleObj } from './type';
import { initialToggleObj } from './initialStates';

interface Props {
  menuDrawerWidth: number;
  setMenuDrawerWidth: (menuDrawerWidth: number) => void;
}

const MenuProfessor = (props: Props) => {
  const { menuDrawerWidth, setMenuDrawerWidth } = props;

  const { student_uuid } = useStudent();
  const { patientInfo } = usePatient();
  const { onRequired } = useNotification();
  const { onUpdateSurveyType } = useSurvey();

  const [toggle, setToggle] = useState<IToggleObj>(initialToggleObj);

  const menus = [
    {
      icon: <PeopleAltOutlinedIcon />,
      label: 'Зөвхөн багшид зориулсан дэлгэц',
      isPro: true,
    },
  ];

  const onClickListItem = (label: string) => {
    if (label === 'Зөвхөн багшид зориулсан дэлгэц') {
      window.open('/#/professorAuth');
      return;
    }

    onUpdateSurveyType(label);
  };

  return (
    <Fragment>
      {menus.map(({ icon, label, isPro }) => {
        const onClick = () => {
          onClickListItem(label);
        };

        const ProIcon = () => {
          if (!isPro) return null;
          return <ProPlus style={{ marginRight: '-7px' }} />;
        };

        // 축소된 메뉴 (52px)
        if (menuDrawerWidth !== 220) {
          if (!icon) return null;

          return (
            <Tooltip
              key={label}
              title={label}
              placement="right"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    fontSize: '14px',
                    padding: '8px 12px',
                    backgroundColor: 'rgba(0, 0, 0, 0.9)',
                  },
                },
                arrow: {
                  sx: {
                    color: 'rgba(0, 0, 0, 0.9)',
                  },
                },
              }}
            >
              <ListItem disablePadding>
                <ListItemButton onClick={onClick}>
                  <ListItemIcon>{icon}</ListItemIcon>
                </ListItemButton>
              </ListItem>
            </Tooltip>
          );
        }

        // 확장된 메뉴 (220px)
        if (icon) {
          return (
            <ListItem key={label} disablePadding>
              <ListItemButton onClick={onClick}>
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText primary={label} />
                <ProIcon />
              </ListItemButton>
            </ListItem>
          );
        }

        if (toggle) {
          return (
            <ListItem key={label} disablePadding>
              <ListItemButton className={''} onClick={onClick}>
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText primary={label} sx={{ whiteSpace: 'pre-wrap' }} />
              </ListItemButton>
            </ListItem>
          );
        }

        return null;
      })}

      <Survey />
    </Fragment>
  );
};

export default MenuProfessor;
